// extracted by mini-css-extract-plugin
export default {"uploaded":"styles_uploaded__tec9b","btn":"styles_btn__T1yff","textUploaded":"styles_textUploaded__pR4V9"};